<template>
  <div class="modal-overlay">
    <div class="modal-container">
      <div class="modal-header">
        <h5>Distributors, Authorized Dealers and Competitors</h5>

        <div class="d-flex align-items-center gap-2">
          <div class="dropdown-container" ref="dropdownContainer">
            <button class="menu-btn" @click="toggleMenu">
              <i class="fas fa-ellipsis-v"></i>
              <span class="tooltip-text">Menu</span>
            </button>

            <div v-if="menuOpen" class="custom-dropdown">
              <div class="dropdown-item" @click="toggleLayer('distributors')">
                <span :class="showDistributors ? 'text-danger' : 'text-muted'">
                  <i
                    :class="
                      showDistributors ? 'fas fa-eye' : 'fas fa-eye-slash'
                    "
                  ></i>
                </span>
                {{ showDistributors ? "Hide" : "Show" }} Distributors
              </div>
              <div class="dropdown-item" @click="toggleLayer('dealers')">
                <span :class="showDealers ? 'text-warning' : 'text-muted'">
                  <i
                    :class="showDealers ? 'fas fa-eye' : 'fas fa-eye-slash'"
                  ></i>
                </span>
                {{ showDealers ? "Hide" : "Show" }} Dealers
              </div>
              <div class="dropdown-item" @click="toggleLayer('competitors')">
                <span :class="showCompetitors ? 'text-primary' : 'text-muted'">
                  <i
                    :class="showCompetitors ? 'fas fa-eye' : 'fas fa-eye-slash'"
                  ></i>
                </span>
                {{ showCompetitors ? "Hide" : "Show" }} Competitors
              </div>
              <div class="dropdown-item" @click="toggleLayer('dual')">
                <span :class="showDual ? 'text-success' : 'text-muted'">
                  <i :class="showDual ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                </span>
                {{ showDual ? "Hide" : "Show" }} Dual
              </div>
            </div>
          </div>

          <button class="btn btn-light close-btn" @click="closeModal">
            <i class="fa-solid fa-xmark"></i>
            <span class="tooltip-text">Close</span>
          </button>
        </div>
      </div>

      <div class="text-center filters-container" :class="{ loading: loading }">
        <!-- <label v-if="userCategory !=='DISTRIBUTOR'" for="distributor">Distributor:&nbsp;</label>
        <select v-if="userCategory !=='DISTRIBUTOR'" id="distributor" v-model="selectedDistributor" class="styled-drop-down"> -->
        <label v-if="!isDistributorLogin" for="distributor"
          >Distributor:&nbsp;</label
        >
        <select
          v-if="!isDistributorLogin"
          id="distributor"
          v-model="selectedDistributor"
          class="styled-drop-down"
        >
          <option disabled value="">Select Distributor</option>
          <option value="">All</option>
          <option
            v-for="distributor in distributorsList"
            :key="distributor.profile_id"
            :value="distributor.profile_id"
          >
            {{ distributor.name }}
          </option>
        </select>
        &nbsp;&nbsp;

        <label for="businessType">Business Type:&nbsp;</label>
        <select
          id="businessType"
          v-model="selectedBusinessType"
          class="styled-drop-down"
        >
          <option disabled value="">Select Business Type</option>
          <option value="">All</option>
          <option
            v-for="type in businessTypesList"
            :key="type.id"
            :value="type.id"
          >
            {{ type.name }}
          </option>
        </select>
        &nbsp;&nbsp;

        <label for="natureOfBusiness">Nature of Business:&nbsp;</label>
        <select
          id="natureOfBusiness"
          v-model="selectedNatureOfBusiness"
          class="styled-drop-down"
          :disabled="!selectedBusinessType"
        >
          <option disabled value="">Select Nature of Business</option>
          <option value="">All</option>
          <option
            v-for="nature in natureOfBusinessList"
            :key="nature.id"
            :value="nature.id"
          >
            {{ nature.businesses_name }}
          </option>
        </select>
        &nbsp;&nbsp;

        <button @click="fetchMapData" class="btn btn-light search-btn">
          <i class="fa-solid fa-magnifying-glass"></i>
          <span class="tooltip-text">Search</span>
        </button>
      </div>

      <div class="modal-body">
        <div id="map-container">
          <div v-if="!loading && error" class="no-data">
            <img
              src="../../../assets/vectors/data_not_found.png"
              alt="No Data"
              class="no-data-image"
            />
            <h3 class="text-center text-danger">{{ error }}</h3>
          </div>

          <div v-show="!loading && !error" ref="mapContainer" class="map"></div>
        </div>

        <div v-if="!loading && !error" class="map-legend">
          <div class="legend-item" v-if="showDistributors">
            <span class="legend-icon distributor"></span>
            <span
              >Distributors ({{ distributors_with_location_count }}/{{
                distributors_count
              }})</span
            >
          </div>
          <div class="legend-item" v-if="showDealers">
            <span class="legend-icon dealer"></span>
            <span
              >Dealers ({{ dealers_with_location_count }}/{{
                dealers_count
              }})</span
            >
          </div>
          <div class="legend-item" v-if="showCompetitors">
            <span class="legend-icon competitor"></span>
            <span
              >Competitors ({{ competitors_with_location_count }}/{{
                competitors_count
              }})</span
            >
          </div>
          <div class="legend-item" v-if="showDual">
            <span class="legend-icon dual"></span>
            <span>Dual ({{ dual_with_location_count }}/{{ dual_count }})</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  fetchDistributorsList,
  fetchBusinessTypesList,
  fetchNatureOfBusinessList,
  filterDealersAndCompetitors,
} from "@/services/dataService";

export default {
  name: "DealerMapModal",
  emits: ["close-modal"],

  data() {
    return {
      token: localStorage.getItem("token_set"),
      profileId: localStorage.getItem("profile_id"),
      userCategory: localStorage.getItem("user_label"),

      // Drop down items
      distributorsList: [],
      businessTypesList: [],
      natureOfBusinessList: [],

      // Filtering Criteria
      selectedDistributor: "",
      selectedBusinessType: "",
      selectedNatureOfBusiness: "",

      // Handling Status
      loading: false,
      error: null,

      // Data Arrays
      dealers: [],
      competitors: [],
      dual: [],
      distributors: [],

      // Counts
      dealers_count: 0,
      dealers_with_location_count: 0,
      competitors_count: 0,
      competitors_with_location_count: 0,
      dual_count: 0,
      dual_with_location_count: 0,
      distributors_count: 0,
      distributors_with_location_count: 0,

      // Menu State
      menuOpen: false,

      // Visibility States
      showDistributors: true,
      showDealers: true,
      showCompetitors: true,
      showDual: true,
    };
  },

  computed: {
    normalizedUserCategory() {
      return String(this.userCategory || "")
        .toUpperCase()
        .trim();
    },

    isDistributorLogin() {
      return ["DISTRIBUTOR", "DISTRIBUTOR BACK OFFICE"].includes(
        this.normalizedUserCategory,
      );
    },

    isMainDistributorLogin() {
      return this.normalizedUserCategory === "DISTRIBUTOR";
    },
  },

  created() {
    // Store Google Map objects here (non-reactive for performance)
    this.map = null;
    this.distributorMarkers = [];
    this.dealerMarkers = [];
    this.competitorMarkers = [];
    this.dualMarkers = [];
    this.distributorValue();
  },

  watch: {
    // Watchers trigger map refresh when data changes
    dealers: {
      handler(val) {
        if (val.length > 0) this.$nextTick(() => this.initMap());
      },
      immediate: true,
    },
    competitors: {
      handler(val) {
        if (val.length > 0) this.$nextTick(() => this.initMap());
      },
      immediate: true,
    },
    // Also watch distributors to ensure they get drawn if they load late
    distributors: {
      handler(val) {
        if (val.length > 0) this.$nextTick(() => this.initMap());
      },
      immediate: true,
    },

    selectedBusinessType(newVal) {
      if (newVal) {
        this.fetchBusinessNatures();
        this.selectedNatureOfBusiness = "";
      }
    },

    loading(val) {
      // When loading finishes (val becomes false) and there is no error
      if (!val && !this.error) {
        // Wait for the DOM to update (so the div reappears) then init map
        this.$nextTick(() => {
          this.initMap();
        });
      }
    },
  },

  mounted() {
    this.enterFullScreen();
    this.loadGoogleMaps();
    this.fetchDistributors();
    this.fetchBusinessTypes();
    this.fetchBusinessNatures();
    this.fetchMapData();
    document.addEventListener("click", this.handleClickOutside);
  },

  beforeUnmount() {
    this.exitFullScreen();
    document.removeEventListener("click", this.handleClickOutside);
    this.clearAllMarkers();
  },

  methods: {
    // --- Menu & Toggle Logic ---
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },

    handleClickOutside(event) {
      if (
        this.$refs.dropdownContainer &&
        !this.$refs.dropdownContainer.contains(event.target)
      ) {
        this.menuOpen = false;
      }
    },

    toggleLayer(type) {
      let markersToToggle = [];
      let isVisible = false;

      switch (type) {
        case "distributors":
          this.showDistributors = !this.showDistributors;
          markersToToggle = this.distributorMarkers;
          isVisible = this.showDistributors;
          break;
        case "dealers":
          this.showDealers = !this.showDealers;
          markersToToggle = this.dealerMarkers;
          isVisible = this.showDealers;
          break;
        case "competitors":
          this.showCompetitors = !this.showCompetitors;
          markersToToggle = this.competitorMarkers;
          isVisible = this.showCompetitors;
          break;
        case "dual":
          this.showDual = !this.showDual;
          markersToToggle = this.dualMarkers;
          isVisible = this.showDual;
          break;
      }

      if (this.map && markersToToggle.length > 0) {
        markersToToggle.forEach((marker) => {
          marker.setMap(isVisible ? this.map : null);
        });
      }
    },

    // --- Standard Methods ---
    enterFullScreen() {
      const elem = document.documentElement;
      if (elem.requestFullscreen) elem.requestFullscreen();
      else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen();
    },

    exitFullScreen() {
      if (document.fullscreenElement || document.webkitFullscreenElement) {
        if (document.exitFullscreen) document.exitFullscreen();
        else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      }
    },

    closeModal() {
      this.$emit("close-modal");
    },

    // distributorValue() {
    //   this.selectedDistributor =
    //     this.userCategory === "DISTRIBUTOR" ? this.profileId : "";
    // },

    distributorValue() {
      this.selectedDistributor = this.isMainDistributorLogin
        ? this.profileId
        : "";
    },

    // --- API Calls ---
    async fetchDistributors() {
      try {
        const response = await fetchDistributorsList(
          this.profileId,
          this.token,
        );
        this.distributorsList = response.data.data || [];
      } catch (error) {
        console.error(error);
      }
    },

    async fetchBusinessTypes() {
      try {
        const response = await fetchBusinessTypesList(this.token);
        this.businessTypesList = response.data.data || [];
      } catch (error) {
        console.error(error);
      }
    },

    async fetchBusinessNatures() {
      try {
        const response = await fetchNatureOfBusinessList(
          { dealer_type_id: this.selectedBusinessType },
          this.token,
        );
        this.natureOfBusinessList = response.data.data || [];
      } catch (error) {
        console.error(error);
      }
    },

    async fetchMapData() {
      try {
        this.loading = true;
        this.error = null;

        // const payload = {
        //   distributors_id: this.selectedDistributor,
        //   nature_of_businesses_id: this.selectedNatureOfBusiness,
        //   dealer_type_id: this.selectedBusinessType,
        //   user_profile_id: this.profileId,
        // };

        const payload = {
          distributors_id: this.isDistributorLogin
            ? this.isMainDistributorLogin
              ? this.profileId
              : ""
            : this.selectedDistributor,

          nature_of_businesses_id: this.selectedNatureOfBusiness,
          dealer_type_id: this.selectedBusinessType,
          user_profile_id: this.profileId,
        };

        const response = await filterDealersAndCompetitors(payload, this.token);

        if (response.data.status) {
          const d = response.data;

          this.dealers_count = d.dealers_count || 0;
          this.dealers_with_location_count = d.dealers_with_location_count || 0;
          this.competitors_count = d.competitors_count || 0;
          this.competitors_with_location_count =
            d.competitors_with_location_count || 0;
          this.dual_count = d.dual_count || 0;
          this.dual_with_location_count = d.dual_with_location_count || 0;
          this.distributors_count = d.distributors_count || 0;
          this.distributors_with_location_count =
            d.distributors_with_location_count || 0;

          const mapLoc = (item) => ({
            name: item.name || item.businessName,
            address: item.address,
            mobile: item.mobile,
            location: {
              lat: parseFloat(item.latitude),
              lng: parseFloat(item.longitude),
            },
          });

          this.dealers = (d.dealers || []).map(mapLoc);
          this.competitors = (d.competitors || []).map(mapLoc);
          this.dual = (d.dual || []).map(mapLoc);
          this.distributors = (d.distributors || []).map(mapLoc);
        } else {
          this.error = response.data.message;
        }
      } catch (e) {
        console.error(e);
        this.error = "Failed to fetch map data.";
      } finally {
        this.loading = false;
      }
    },

    // --- Map Logic ---
    loadGoogleMaps() {
      if (window.google && window.google.maps) {
        this.initMap();
      } else {
        const script = document.createElement("script");
        const googleKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;
        script.src = `https://maps.googleapis.com/maps/api/js?key=${googleKey}&callback=initMap`;
        script.defer = true;
        script.async = true;
        script.onload = () => this.initMap();
        document.head.appendChild(script);
      }
    },

    clearAllMarkers() {
      const allMarkers = [
        ...this.distributorMarkers,
        ...this.dealerMarkers,
        ...this.competitorMarkers,
        ...this.dualMarkers,
      ];
      allMarkers.forEach((m) => m.setMap(null));

      this.distributorMarkers = [];
      this.dealerMarkers = [];
      this.competitorMarkers = [];
      this.dualMarkers = [];
    },

    initMap() {
      if (!this.$refs.mapContainer) return;

      // Initialize map only if it doesn't exist
      if (!this.map) {
        this.map = new google.maps.Map(this.$refs.mapContainer, {
          center: { lat: 7.8731, lng: 80.7718 },
          zoom: 7,
        });
      }

      this.clearAllMarkers();

      // --- Dealers ---
      this.dealers.forEach((d) => {
        const marker = this.createMarker(d, "#f4b400");
        this.dealerMarkers.push(marker);
        if (this.showDealers) marker.setMap(this.map);
      });

      // --- Competitors ---
      this.competitors.forEach((c) => {
        const marker = this.createMarker(c, "#4285f4");
        this.competitorMarkers.push(marker);
        if (this.showCompetitors) marker.setMap(this.map);
      });

      // --- Dual ---
      this.dual.forEach((du) => {
        const marker = this.createMarker(du, "#28a745");
        this.dualMarkers.push(marker);
        if (this.showDual) marker.setMap(this.map);
      });

      // --- Distributors ---
      this.distributors.forEach((di) => {
        const marker = new google.maps.Marker({
          position: di.location,
          draggable: false,
          title: `(${di.location.lat},${di.location.lng})`,
          icon: this.createDistributorIcon(),
        });
        this.addInfoWindow(marker, di);
        this.distributorMarkers.push(marker);
        if (this.showDistributors) marker.setMap(this.map);
      });
    },

    createMarker(data, color) {
      const marker = new google.maps.Marker({
        position: data.location,
        draggable: false,
        title: `(${data.location.lat},${data.location.lng})`,
        icon: this.createCustomIcon(color),
      });
      this.addInfoWindow(marker, data);
      return marker;
    },

    addInfoWindow(marker, data) {
      const infoWindow = new google.maps.InfoWindow({
        disableAutoPan: true,
        content: `
            <div class="dealer-info">
              <span style="font-weight: 600">${data.name}</span><br>
              Address: ${data.address}<br>
              Mobile: ${data.mobile}<br>
            </div>
          `,
      });

      marker.addListener("mouseover", () => {
        infoWindow.open(this.map, marker);
        // Small delay to hide the close button (x)
        setTimeout(() => {
          const closeButton = document.querySelector(".gm-ui-hover-effect");
          if (closeButton) closeButton.style.display = "none";
        }, 10);
      });

      marker.addListener("mouseout", () => {
        infoWindow.close();
      });
    },

    createCustomIcon(color) {
      const svgIcon = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="40" height="40">
          <path fill="${color}" d="M128 252.6C128 148.4 214 64 320 64C426 64 512 148.4 512 252.6C512 371.9 391.8 514.9 341.6 569.4C329.8 582.2 310.1 582.2 298.3 569.4C248.1 514.9 127.9 371.9 127.9 252.6zM320 320C355.3 320 384 291.3 384 256C384 220.7 355.3 192 320 192C284.7 192 256 220.7 256 256C256 291.3 284.7 320 320 320z"/>
        </svg>
      `;
      return {
        url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svgIcon),
        scaledSize: new google.maps.Size(40, 40),
        anchor: new google.maps.Point(20, 40),
      };
    },

    createDistributorIcon() {
      const svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="40" height="40"><path fill="#dc3545" d="M32 206.1L32 544C32 561.7 46.3 576 64 576C81.7 576 96 561.7 96 544L96 304C96 286.3 110.3 272 128 272L512 272C529.7 272 544 286.3 544 304L544 544C544 561.7 558.3 576 576 576C593.7 576 608 561.7 608 544L608 206.1C608 178.6 590.4 154.1 564.2 145.4L335.2 69.1C325.3 65.8 314.7 65.8 304.8 69.1L75.8 145.4C49.6 154.1 32 178.6 32 206.1zM496 320L144 320L144 384L496 384L496 320zM144 480L496 480L496 416L144 416L144 480zM496 512L144 512L144 576L496 576L496 512z"/></svg>`;
      return {
        url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svgIcon),
        scaledSize: new google.maps.Size(20, 20),
        anchor: new google.maps.Point(20, 20),
      };
    },
  },
};
</script>

<style scoped>
/* --- Menu Styles --- */
.dropdown-container {
  position: relative;
}

.menu-btn {
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 50%; /* Circle to match close button */
  width: 33px;
  height: 33px;
  padding: 0;
  color: #333;
  cursor: pointer;
  transition: background 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-btn:hover {
  background-color: #e2e6ea;
}

.custom-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 5px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 180px;
  overflow: hidden;
}

.dropdown-item {
  padding: 10px 15px;
  cursor: pointer;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #333;
}

.dropdown-item:hover {
  background-color: #f1f1f1;
}

/* Icons */
.text-danger {
  color: #dc3545 !important;
}

.text-warning {
  color: #f4b400 !important;
}

.text-primary {
  color: #4285f4 !important;
}

.text-success {
  color: #28a745 !important;
}

.text-muted {
  color: #ccc !important;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6); /* Slightly darker for better contrast */
  backdrop-filter: blur(3px); /* Optional: Adds a modern blur effect */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999 !important;
}

.modal-container {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 1200px;
  max-width: 90%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h5 {
  text-transform: none !important;
}

.filters-container {
  margin-top: 15px;
  align-items: start;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
}

/* Loading Bar */
.filters-container.loading {
  position: relative;
  border-bottom: none;
}

.filters-container.loading::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 3px;
  background: linear-gradient(to right, #0d6efd, #28a745, #f4b400, #dc3545);
  animation: loadingBar 1.5s linear infinite;
}
@keyframes loadingBar {
  0% {
    width: 0;
  }
  50% {
    width: 50%;
  }
  100% {
    width: 100%;
  }
}

.close-btn {
  border-radius: 50%;
  width: 33px;
  height: 33px;
  padding: 0;
  cursor: pointer;
}

#map-container {
  width: 100%;
  height: 450px;
  background: #f4f4f4;
  border-radius: 8px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.map {
  width: 100%;
  height: 100%;
}

.no-data {
  text-align: center;
  color: #666;
}

.no-data-image {
  max-width: 175px;
  margin-bottom: 10px;
}

.map-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 20px;
  padding-top: 12px;
  justify-content: center;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  white-space: nowrap;
}

.legend-icon {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.legend-icon.distributor {
  background-color: #dc3545;
}

.legend-icon.dealer {
  background-color: #f4b400;
}

.legend-icon.competitor {
  background-color: #4285f4;
}

.legend-icon.dual {
  background-color: #28a745;
}

.styled-drop-down {
  padding: 5px 10px;
  font-size: 14px;
  border: 1px solid #cccccc;
  border-radius: 6px;
  outline: none;
  background-color: #fff;
  color: #333;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.styled-drop-down:hover,
.styled-drop-down:focus {
  border-color: #666;
}

.styled-drop-down:disabled {
  background-color: #f0f0f0;
  cursor: not-allowed;
}

.search-btn {
  border-radius: 5px;
  width: 33px;
  height: 33px;
  padding: 0;
}

.tooltip-text {
  visibility: hidden;
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 6px 10px;
  border-radius: 4px;
  position: absolute;
  bottom: 40px;
  right: 50%;
  transform: translateX(50%);
  white-space: nowrap;
  font-size: 12px;
  z-index: 1001;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.search-btn:hover .tooltip-text,
.close-btn:hover .tooltip-text,
.menu-btn:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
</style>
